import request from '../utils/request';
import appConst from '../const/app.const';

export default class {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  static checkAgeIsAdult(): Promise<{
    isadult?: boolean;
    isrealname?: boolean;
    info?: string;
  }> {
    return request
      .post(
        {
          action: 'user.ev.ridecard.checkAgeIsAdult',
        },
        {
          apiServer: appConst.EBIKE_API,
        },
        true,
      )
      .then((res: any) => (res && res.data) || {});
  }

  static zeroDepositToPlatform(options: any): any {
    return request.post(
      {
        action: 'user.evbike.poweruser.zeroDepositToPlatform',
        ...options,
        systemCode: 65,
      },
      {
        apiServer: appConst.EBIKE_API,
      },
      true,
    ) as any;
  }

  /**
   * 钱包账户信息
   * @link https://yapi.hellobike.cn/project/41/interface/api/50118
   */
  static getAccountWalletInfo(params: { cityCode?: string; adCode?: string }) {
    const { cityCode, adCode } = params;
    return request.post(
      {
        adCode,
        cityCode,
        action: 'user.wallet.account',
      },
      {
        apiServer: appConst.API,
      },
      true,
    ) as any;
  }

  /**
   * 助力车 专用 钱包账户信息
   * @link https://yapi.hellobike.cn/project/42/interface/api/51224
   */
  static getEvBikeFundsInfo(params: {
    adCode?: string;
    cityCode?: string;
    city?: string;
    province?: string;
  }): Promise<{ hasFreeApply?: boolean; zmxyFreeScore?: number }> {
    const { adCode, cityCode, city, province } = params;
    return request.post(
      {
        adCode,
        cityCode,
        city: (city && city.length && city) || province,
        action: 'user.ev.getFundsInfo',
      },
      { apiServer: appConst.EBIKE_API },
      true,
    ) as any;
  }

  // 获取助力车月卡信息
  static getEvBikeMonthCardInfo(params: {
    cityCode?: string;
    adCode?: string;
    needCardRule?: boolean;
    cardType?: number;
  }) {
    const { cityCode, adCode, needCardRule } = params;
    return request.post(
      {
        cityCode,
        adCode,
        needCardRule,
        action: 'user.ev.ridecard.cardInfo',
        systemCode: 65,
      },
      { apiServer: appConst.EBIKE_API },
      true,
    ) as any;
  }

  /**
   * 可用月卡套餐列表
   * @link https://yapi.hellobike.cn/project/939/interface/api/7692
   */
  static getEvBikeMonthCard(params: {
    cityCode: string;
    adCode: string;
    cardType?: number;
  }): Promise<any> {
    const { cityCode, adCode, cardType = 1 } = params;
    return request.post(
      {
        action: 'user.ev.ridecard.packageList',
        cityCode,
        adCode,
        cardType,
        systemCode: 65,
      },
      { apiServer: appConst.EBIKE_API },
      true,
    ) as any;
  }

  /**
   * 查询城市是否配置了0元免押
   * @link https://yapi.hellobike.cn/project/2057/interface/api/26898
   */
  static cityDepositConfig(params: {
    adCode: string;
    cityCode: string;
    systemCode?: number;
  }): Promise<{
    zeroDeposit: boolean; // 是否配置了0元免押
    iconUrl?: string; // 规则配置url
  }> {
    return request.post(
      {
        action: 'user.evbike.poweruser.cityDepositConfig',
        systemCode: 65,
        ...params,
      },
      {
        apiServer: appConst.EBIKE_API,
      },
      true,
    ) as any;
  }

  /**
   * 创建交押金订单
   */
  static createDepositOrder(params: {
    amount: number;
    adCode: string;
    cityCode: string;
  }): Promise<any> {
    const { amount, adCode, cityCode } = params;
    return request.post(
      {
        action: 'com.alphapay.payDeposit',
        cityCode,
        adCode,
        amount,
      },
      { apiServer: appConst.API },
      true,
    );
  }

  static chargeWallet({
    amount,
  }: {
    amount: number;
    adCode: string;
    cityCode: string;
  }): Promise<any> {
    return this.preOrder({ amount, type: 1 });
  }

  // pearl-hellobike/hello bike/hellobike--用户充值退款
  // @link https://yapi.hellobike.cn/project/29/interface/api/908
  static preOrder(options: any = {}): Promise<any> {
    const { adCode, cityCode } = options;
    return request.post(
      {
        action: 'user.deposit.miniProAliPayPreOrder',
        cityCode,
        adCode,
        // bikeNo: MainStore.state.fromBikeNo,
        // activityFrom: MainStore.state.activityFrom,
        ...options,
      },
      null,
      true,
    );
  }

  // 用户基本信息
  // https://yapi.hellobike.cn/project/41/interface/api/50074
  static getAccountBasicInfo(params: {
    adCode?: string;
    cityCode?: string;
  }): Promise<any> {
    const { adCode, cityCode } = params;
    return request.post(
      {
        adCode,
        cityCode,
        action: 'user.account.basicInfo',
      },
      {},
      true,
    ) as any;
  }

  /**
   * 获取芝麻信用分
   * @link https://yapi.hellobike.cn/project/41/interface/api/962
   */
  static checkZmxyScore(params: {
    code?: number;
    autoRefund?: boolean;
    source?: string;
    adCode?: string;
    cityCode?: string;
  }): Promise<{
    zmxyNotOpen?: boolean;
    evaluateId?: string;
    zmxyFreeResult?: string; // 芝麻免押结果true:通过，false:不达标
  }> {
    const { code, autoRefund, source, adCode, cityCode } = params;
    return request.post(
      {
        source,
        code,
        autoRefund,
        cityCode,
        adCode,
        action: 'user.account.checkZmxyScore',
        apiServer: appConst.API,
        systemCode: 65,
      },
      null,
      true,
    ) as any;
  }

  // 助力车收银台购卡预下单
  static purchaseCardPreorder({
    cityCode,
    adCode,
    cardInfoGuid,
    packageGuid,
    evCouponGuid,
    paySchemeGuid,
    equityGuid,
    amount,
    type,
    expireRefund,
  }: any): Promise<{
    guid: string;
    payOrdeGuid?: string;
    orderId?: string;
    amount?: string;
    autoRenewal?: string;
  }> {
    return request.post(
      {
        cityCode,
        adCode,
        action: 'user.ev.card.pre.order',
        cardInfoGuid,
        packageGuid,
        evCouponGuid,
        paySchemeGuid,
        equityGuid,
        amount,
        type,
        expireRefund,
        systemCode: 65,
      },
      { apiServer: appConst.EBIKE_API },
      true,
    ) as any;
  }

  // 平台支付订单。
  // 这个接口主要是用在押金交付模拟收银台行为上面，因为小程序里面的H5需要直接唤起支付宝支付。
  static paymentOrder(params: {
    amount: string | number;
    channel: string;
    orders: {
      guid: string;
      orderId: string;
      amount: string | number;
      businessType: string;
    }[];
  }): Promise<{
    credential: {
      method: string;
      params: string;
    };
    guid: string;
    status: string;
  }> {
    const { amount, channel, orders } = params;
    return request.post(
      {
        action: 'com.alphapay.paymentOrder.pay',
        actionOrigin: 'StandardCashier',
        amount,
        channel,
        orders: JSON.stringify(orders),
      },
      {
        apiServer: appConst.API,
      },
      true,
    ) as any;
  }
}
